export default "__VITE_ASSET__e3bccc28__"